module.exports = __webpack_public_path__ + "img/mobile-mockup.1247586f.png";